import { isLikelyHtml } from "utils/html-detect.util";

/**
 * Rolling-deploy bridge: if the BE returned HTML, pass through;
 * if it returned plaintext (old BE without format support),
 * convert \n → <br /> so line breaks render in HTML contexts.
 *
 * HTML detection requires a leading tag — see isLikelyHtml in html-detect.util.ts.
 * Remove once all BE instances support format: "html".
 */
export function ensureHtmlLineBreaks(text: string | undefined | null): string {
  if (!text) return "";
  return isLikelyHtml(text) ? text : text.replaceAll("\n", "<br />");
}
